<template>
  <el-container>
    <el-aside class="app_aside">
      <div class="app_logo">
        <img src="../assets/logo.png" alt="">
      </div>
      <MyAside :asideId="app_asideId"></MyAside>
    </el-aside>
    <el-container>
      <el-header>
        <MyHeader></MyHeader>
      </el-header>
      <div class="app_con">
        <div class="app_Rig app_RigW">
          <div class="app_TNav">
            <div class="app_TList">

              <div class="app_TItem"
                   v-for="(todo, index) in todos"
                   :class="{ app_TAct: activeTabIndex === index }"
                   @click="switchTab(index)">
                {{todo.title}} <i class="el-icon-close" @click="removeTodo(index)" v-if="index>0"></i>
              </div>
            </div>
          </div>
          <el-main>
            <div class="app_mMBox">
              <div class="app_mMItem" @click="sxsjon(1)" :class="{active: sxsj === 1 }">
                全部
              </div>
              <div class="app_mMItem" @click="sxsjon(2)" :class="{active: sxsj === 2 }">
                当日
              </div>
              <div class="app_mMItem" @click="sxsjon(3)" :class="{active: sxsj === 3 }">
                本月
              </div>
              <div class="app_mMItem" @click="sxsjon(4)" :class="{active: sxsj === 4 }">
                本季度
              </div>
              <div class="app_mMItem" @click="sxsjon(5)" :class="{active: sxsj === 5 }">
                本年
              </div>
              <el-date-picker v-model="sxsjtime" type="daterange" range-separator="至"
                              start-placeholder="开始日期" end-placeholder="结束日期"> </el-date-picker>
            </div>
            <div class="app_mian">
              <div class="app_mianCon">
                <div class="app_mdBox">
                  <div class="app_mdItem">
                    <div class="app_mdIcon">
                      <svg t="1724315538696" class="icon" viewBox="0 0 1024 1024" version="1.1"
                           xmlns="http://www.w3.org/2000/svg" p-id="16942" width="200"
                           height="200">
                        <path
                            d="M945.93 130.759c-7.638-15.276-26.279-21.619-41.684-13.981L92.312 520.027c-15.276 7.638-21.619 26.279-13.981 41.684 1.683 3.365 3.884 6.343 6.473 8.803 3.365 3.237 7.378 5.696 12.169 7.249l273.148 85.828 41.943-52.041-222.919-70.035 611.539-303.957-327.131 395.999a22.868 22.868 0 0 0-2.071 2.848l-37.801 46.991v194.957c0 17.218 13.852 31.069 31.069 31.069s31.069-13.852 31.069-31.069v-175.54l297.097 93.206c3.495 1.036 6.991 1.553 10.485 1.423 15.017 0.388 28.609-10.227 31.457-25.502l113.79-621.507c0.388-2.071 0.517-4.272 0.517-6.343-0.13-4.402-1.036-9.062-3.237-13.333zM779.969 726.893l-240.396-75.472L866.314 255.81l-86.346 471.082z"
                            fill="#333333" p-id="16943"></path>
                      </svg>
                    </div>
                    <p>总订单(条)</p>
                    <div class="app_mdNum">
                      <b>{{dataall.znum}}</b>
                    </div>
                  </div>
                  <div class="app_mdItem">
                    <div class="app_mdIcon">
                      <svg t="1724315934179" class="icon" viewBox="0 0 1024 1024" version="1.1"
                           xmlns="http://www.w3.org/2000/svg" p-id="18000" width="200"
                           height="200">
                        <path
                            d="M372.893538 1024H94.523077a94.523077 94.523077 0 0 1-94.523077-94.523077V94.523077a94.523077 94.523077 0 0 1 94.523077-94.523077h693.169231a94.523077 94.523077 0 0 1 94.523077 94.523077v236.307692a31.507692 31.507692 0 0 1-63.015385 0V94.523077a31.507692 31.507692 0 0 0-31.507692-31.507692H94.523077a31.507692 31.507692 0 0 0-31.507692 31.507692v834.953846a31.507692 31.507692 0 0 0 31.507692 31.507692h278.370461a31.507692 31.507692 0 0 1 0 63.015385z"
                            fill="#727272" p-id="18001"></path>
                        <path
                            d="M661.661538 283.569231H173.292308a31.507692 31.507692 0 0 1 0-63.015385h488.36923a31.507692 31.507692 0 0 1 0 63.015385zM330.830769 519.876923H173.292308a31.507692 31.507692 0 0 1 0-63.015385h157.538461a31.507692 31.507692 0 0 1 0 63.015385zM267.815385 756.184615h-94.523077a31.507692 31.507692 0 0 1 0-63.015384h94.523077a31.507692 31.507692 0 0 1 0 63.015384zM708.923077 1024a315.076923 315.076923 0 1 1 315.076923-315.076923 315.076923 315.076923 0 0 1-315.076923 315.076923z m0-567.138462a252.061538 252.061538 0 1 0 252.061538 252.061539 252.061538 252.061538 0 0 0-252.061538-252.061539z"
                            fill="#727272" p-id="18002"></path>
                        <path
                            d="M756.184615 850.707692a32.610462 32.610462 0 0 1-12.130461-2.363077A31.507692 31.507692 0 0 1 724.676923 819.2v-63.015385H567.138462a31.507692 31.507692 0 0 1 0-63.015384h189.046153a31.507692 31.507692 0 0 1 31.507693 31.507692v18.432l26.308923-26.308923-64.275693-64.433231a31.507692 31.507692 0 0 1 44.425847-44.425846l86.646153 86.646154a31.507692 31.507692 0 0 1 0 44.425846l-102.4 102.4A31.507692 31.507692 0 0 1 756.184615 850.707692z"
                            fill="#727272" p-id="18003"></path>
                      </svg>
                    </div>
                    <p>进行中(条)</p>
                    <div class="app_mdNum">
                      <b>{{dataall.jxz}}</b>
                    </div>
                  </div>
                  <div class="app_mdItem" v-if="userpath==2">
                    <div class="app_mdIcon">
                      <svg t="1724315981836" class="icon" viewBox="0 0 1024 1024" version="1.1"
                           xmlns="http://www.w3.org/2000/svg" p-id="19911" width="200"
                           height="200">
                        <path
                            d="M803.2 960H220.8C152 960 96 907.6 96 843.1V180.9C96 116.4 152 64 220.8 64h582.4C872 64 928 116.4 928 180.9v662.3c0 64.4-56 116.8-124.8 116.8zM220.8 141.9c-22.9 0-41.6 17.5-41.6 39v662.3c0 21.5 18.7 39 41.6 39h582.4c22.9 0 41.6-17.5 41.6-39V180.9c0-21.5-18.7-39-41.6-39H220.8z"
                            fill="#333333" p-id="19912"></path>
                        <path
                            d="M574.4 687.3h-208c-23 0-41.6-17.4-41.6-39 0-21.5 18.6-39 41.6-39h208c45.9 0 83.2-34.9 83.2-77.9 0-43-37.3-77.9-83.2-77.9h-208c-23 0-41.6-17.4-41.6-39s18.6-39 41.6-39h208c91.8 0 166.4 69.9 166.4 155.8s-74.6 156-166.4 156z"
                            fill="#333333" p-id="19913"></path>
                        <path
                            d="M428.8 563.7c-10.6 0-21.3-3.8-29.4-11.4L281.7 442.2c-16.3-15.2-16.3-39.9 0-55.1l117.7-110.2c16.2-15.2 42.6-15.2 58.8 0 16.3 15.2 16.3 39.9 0 55.1L370 414.6l88.2 82.6c16.3 15.2 16.3 39.9 0 55.1-8.1 7.7-18.8 11.4-29.4 11.4z"
                            fill="#333333" p-id="19914"></path>
                      </svg>
                    </div>
                    <p>待审核订单(条)</p>
                    <div class="app_mdNum">
                      <b>{{dataall.zcd}}</b>
                    </div>
                  </div>
                  <div class="app_mdItem" v-else>
                    <div class="app_mdIcon">
                      <svg t="1724315981836" class="icon" viewBox="0 0 1024 1024" version="1.1"
                           xmlns="http://www.w3.org/2000/svg" p-id="19911" width="200"
                           height="200">
                        <path
                            d="M803.2 960H220.8C152 960 96 907.6 96 843.1V180.9C96 116.4 152 64 220.8 64h582.4C872 64 928 116.4 928 180.9v662.3c0 64.4-56 116.8-124.8 116.8zM220.8 141.9c-22.9 0-41.6 17.5-41.6 39v662.3c0 21.5 18.7 39 41.6 39h582.4c22.9 0 41.6-17.5 41.6-39V180.9c0-21.5-18.7-39-41.6-39H220.8z"
                            fill="#333333" p-id="19912"></path>
                        <path
                            d="M574.4 687.3h-208c-23 0-41.6-17.4-41.6-39 0-21.5 18.6-39 41.6-39h208c45.9 0 83.2-34.9 83.2-77.9 0-43-37.3-77.9-83.2-77.9h-208c-23 0-41.6-17.4-41.6-39s18.6-39 41.6-39h208c91.8 0 166.4 69.9 166.4 155.8s-74.6 156-166.4 156z"
                            fill="#333333" p-id="19913"></path>
                        <path
                            d="M428.8 563.7c-10.6 0-21.3-3.8-29.4-11.4L281.7 442.2c-16.3-15.2-16.3-39.9 0-55.1l117.7-110.2c16.2-15.2 42.6-15.2 58.8 0 16.3 15.2 16.3 39.9 0 55.1L370 414.6l88.2 82.6c16.3 15.2 16.3 39.9 0 55.1-8.1 7.7-18.8 11.4-29.4 11.4z"
                            fill="#333333" p-id="19914"></path>
                      </svg>
                    </div>
                    <p>待接单(条)</p>
                    <div class="app_mdNum">
                      <b>{{dataall.zcd}}</b>
                    </div>
                  </div>
                  <div class="app_mdItem">
                    <div class="app_mdIcon">
                      <svg t="1724316782237" class="icon" viewBox="0 0 1024 1024" version="1.1"
                           xmlns="http://www.w3.org/2000/svg" p-id="23714" width="200"
                           height="200">
                        <path
                            d="M519.623698 499.213625c-11.402931 0-16.014411 8.384508-16.098256 18.445918v108.327847c0 9.642185 2.850733 18.194383 15.51134 18.529764s16.769017-8.384508 16.769017-18.697454V517.491853c0.083845-9.809875-4.443789-18.445918-16.182101-18.278228zM519.372163 683.672808a14.253664 14.253664 0 0 0-15.427496 14.840579 14.84058 14.84058 0 0 0 15.175961 16.769017c10.39679 0.586916 14.924425-6.288381 16.769016-15.846721-2.012282-9.139114-6.120691-15.679031-16.517481-15.762875z"
                            fill="#32A66B" p-id="23715"></path>
                        <path
                            d="M967.440287 960.110047q-26.998117-358.689266-52.906248-717.546222c-3.353803-46.869401-11.822157-56.092361-59.278473-56.09236H714.982742c-1.425366-74.286744-55.170065-148.908868-125.767625-173.056252A195.275199 195.275199 0 0 0 520.713684 0C412.637372 0.838451 320.659316 88.372718 320.156245 186.303775H163.617475c-39.155654 0-47.791697 7.546057-51.816261 46.701711-3.689184 36.388766-5.785311 73.029067-8.384509 109.585524Q80.023927 651.392451 56.631149 959.942357c-3.856874 49.468599 8.384508 63.973798 59.194629 63.973798h795.270613c48.043233-0.083845 59.949234-15.00827 56.343896-63.806108zM511.23919 38.233358c85.857365-2.096127 150.082699 54.415459 164.504053 144.632768 0 1.173831 0 2.347662 0.586915 3.521494h-100.614099c-17.523622 0-26.830427-2.096127-26.327356-23.225088 0.586916-22.470482-15.00827-34.292639-36.556457-34.544175s-37.981823 11.570621-37.394907 33.538034c0.670761 23.728159-11.151396 24.063539-28.675018 23.979694H358.641138c10.480635-86.192745 72.022926-145.97429 152.598052-147.902727z m306.034553 910.725293H512.413021c-117.383116 0-234.766233-0.50307-352.149349 0-20.374355 0-26.830427-4.443789-25.153525-25.908131q25.153525-317.940555 47.456317-635.964955c1.593057-20.877426 7.546057-27.165807 29.513469-27.165807q300.081552 1.257676 600.07926 0c23.812004 0 30.01654 7.546057 31.441906 29.597314 12.660608 192.256776 26.243511 384.513551 39.491034 576.770327 0 4.108409 0 8.384508 0.754606 12.492917 5.11455 70.178335 5.11455 70.178335-66.572996 70.178335z"
                            fill="#37A96E" p-id="23716"></path>
                        <path
                            d="M517.108346 430.041431a176.074675 176.074675 0 1 1-176.074675 176.074675 176.074675 176.074675 0 0 1 176.074675-176.074675m0-50.30705a226.381724 226.381724 0 1 0 0 452.763449 226.381724 226.381724 0 1 0 0-452.763449z"
                            fill="#32A66B" p-id="23717"></path>
                      </svg>
                    </div>
                    <p>撤销订单(条)</p>
                    <div class="app_mdNum">
                      <b>{{dataall.zjf}}</b>
                    </div>
                  </div>
                  <div class="app_mdItem">
                    <div class="app_mdIcon">
                      <svg t="1724316093759" class="icon" viewBox="0 0 1024 1024" version="1.1"
                           xmlns="http://www.w3.org/2000/svg" p-id="21112" width="200"
                           height="200">
                        <path
                            d="M783.2064 673.28a36.0448 36.0448 0 0 0-35.9424 35.84v89.6H225.536V225.28h521.728v189.952a35.7376 35.7376 0 0 0 35.9424 35.84 36.0448 36.0448 0 0 0 35.9936-35.84V221.696a69.6832 69.6832 0 0 0-44.9536-63.488 70.4 70.4 0 0 0-26.9824-4.608H225.536a70.4 70.4 0 0 0-65.8944 41.472A69.632 69.632 0 0 0 153.6 221.696v580.608c0.512 18.4832 8.3968 36.0448 21.8624 48.8448 13.4656 12.7488 31.488 19.6608 50.0736 19.2512h521.728c18.5856 0.4096 36.608-6.5024 50.0736-19.2512 13.4656-12.8 21.3504-30.3616 21.8624-48.8448v-93.184a35.7376 35.7376 0 0 0-35.9936-35.84z"
                            fill="#111032" p-id="21113"></path>
                        <path
                            d="M661.6576 392.8064a33.8432 33.8432 0 0 0-10.3936-24.32 35.9936 35.9936 0 0 0-25.0368-10.0864H342.6304c-9.3696 0-18.432 3.584-25.088 10.0864A33.8432 33.8432 0 0 0 307.2 392.8064c0 9.1136 3.7376 17.8176 10.3936 24.2688s15.6672 10.0864 25.088 10.0864h283.5456a36.352 36.352 0 0 0 25.088-10.0864 34.304 34.304 0 0 0 10.3424-24.2688z m-318.976 137.5232c-9.4208 0-18.432 3.584-25.088 10.0352a33.8432 33.8432 0 0 0 0 48.64c6.656 6.4512 15.6672 10.0864 25.088 10.0864h177.152c9.4208 0 18.432-3.6352 25.088-10.0864a33.8432 33.8432 0 0 0 10.3936-24.32 33.8432 33.8432 0 0 0-10.3936-24.32 35.9936 35.9936 0 0 0-25.088-10.0352h-177.152z m517.3248-16.384a35.5328 35.5328 0 0 0-25.088-10.0352 36.352 36.352 0 0 0-25.088 10.0864l-175.4624 171.008-49.9712-48.64a36.0448 36.0448 0 0 0-50.176 0 33.8944 33.8944 0 0 0-10.3936 24.32c0 9.1136 3.7376 17.92 10.3936 24.32l75.1616 72.9088a35.584 35.584 0 0 0 25.088 10.0864 36.4032 36.4032 0 0 0 25.088-10.0864l200.448-195.2768a34.2528 34.2528 0 0 0 10.3936-24.32 33.4336 33.4336 0 0 0-10.3936-24.32z"
                            fill="#111032" p-id="21114"></path>
                      </svg>
                    </div>
                    <p>完结订单(条)</p>
                    <div class="app_mdNum">
                      <b>{{dataall.zwj}}</b>
                    </div>
                  </div>
                </div>
                <!-- 订单统计 -->
                <div class="app_mSBox">
                  <div class="app_mSTit">
                    <p>订单统计</p>
                  </div>
                  <div class="app_mSTBox">
                    <div class="app_mSTt" ref="main1">

                    </div>
                  </div>
                </div>
                <div class="app_mlBox">
                  <div class="app_mlTop">
                    <p>任务列表</p>
                    <div class="app_mlRig" @click="handleCurrentChange(this.onpage)">
                      <i class="el-icon-refresh-right app_mlIcon"></i>
                    </div>
                  </div>
                  <div class="app_mlTable">
                    <el-table :data="tableData">
                      <el-table-column fixed prop="bh" label="任务编号" width="150">
                      </el-table-column>
                      <el-table-column prop="state" label="状态" width="120">
                      </el-table-column>
                      <el-table-column prop="type" label="类型" width="200">
                      </el-table-column>
                      <el-table-column prop="xcon" label="需求描述" min-width="250">
                      </el-table-column>
                      <el-table-column prop="yjprice" label="任务佣金" width="150">
                      </el-table-column>
                      <el-table-column prop="bzprice" label="保证金" width="150">
                      </el-table-column>
                      <el-table-column prop="jgtime" label="交稿时间" width="150">
                      </el-table-column>
                      <el-table-column fixed="right" label="操作" width="120">
                        <template slot-scope="scope">
                          <el-button class="app_mlTableCk" type="text" size="small" @click="detailsShowa(scope.row.id)">查看</el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                  <div class="app_page" v-if="tableData.length>0">
                    <el-pagination
                        @size-change="sizechange"
                        @current-change="handleCurrentChange"
                        layout="sizes, prev, pager, next"
                        :page-sizes="[10,50,80,100]" :page-size="10" :total="pagesize" :current-page="onpage">
                    </el-pagination>
                  </div>
                  <el-empty description="暂无数据" v-else></el-empty>
                </div>
              </div>
              <div class="app_mianRig">
                <div class="app_mgBox">
                  <div class="app_mglogo">
                    <img :src="dataall.user.tx" alt="">
                  </div>
                  <div class="app_mgTit">{{dataall.user.name}}</div>
                  <div class="app_mgItem">
                    手机号：{{dataall.user.title}}
                  </div>
                  <div class="app_mgItem">
                    邀请码：{{dataall.user.yqm}}
                  </div>
                  <div class="app_mgItem">
                    最近登录：{{dataall.user.lasttime}}
                  </div>
                  <div class="app_mgItem">
                    密码设置：****** <span @click="dialogFormVisible = true" type="primary">修改</span>
                  </div>
<!--                  <div class="app_mgItem">-->
<!--                      支付宝：未绑定 <span @click="alipaytShow = true">去绑定</span>-->
<!--                  </div>-->

                  <router-link to="/usercenter" class="app_mgBtn">完善基本信息</router-link>
                </div>
                <div class="app_mjBox">
                  <div class="app_mjTit">订单价格区间分布</div>
                  <div class="app_mjMap" ref="main2">
                    <!-- <div></div> -->
                  </div>
                </div>
              </div>
            </div>
            <el-dialog title="修改密码" class="Password" :visible.sync="dialogFormVisible">
              <el-form :model="passwordForm" label-width="100px">
                <el-form-item label="旧密码">
                  <el-input v-model="passwordForm.jiu_password" placeholder="请输入旧密码"></el-input>
                </el-form-item>
                <el-form-item label="输入新密码">
                  <el-input v-model="passwordForm.new_password" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="确定新密码">
                  <el-input v-model="passwordForm.qnew_password" autocomplete="off"></el-input>
                </el-form-item>
              </el-form>
              <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false;passwordForm=[]" class="Password_hide">取 消</el-button>
                <el-button type="primary" @click="MImaShowa">确 定</el-button>
              </div>
            </el-dialog>
            <el-dialog title="修改支付宝" class="Password" :visible.sync="alipaytShow">
              <el-form :model="alipaytForm" label-width="100px">
                <el-form-item label="当前手机号">
                  <div class="accountNum">18868732329</div>
                </el-form-item>
                <el-form-item label="手机验证码">
                  <el-input v-model="alipaytForm.Code" placeholder="请输入验证码"></el-input>
                  <div class="accountYz">获取验证码</div>
                </el-form-item>
                <el-form-item label="修改支付宝号">
                  <el-input v-model="alipaytForm.alipayt" placeholder="请输入新的支付宝账号"></el-input>
                </el-form-item>
              </el-form>
              <div slot="footer" class="dialog-footer">
                <el-button @click="alipaytShow = false" class="Password_hide">取 消</el-button>
                <el-button type="primary" @click="alipaytShow = false">确 定</el-button>
              </div>
            </el-dialog>
            <el-dialog title="订单详情" class="TaskDetails" :visible.sync="detailsShow">
              <div class="TaskDTbox" v-html="listcon.html">
              </div>
              <div slot="footer" class="dialog-footer">
                <el-button @click="detailsShow = false" class="Password_hide">关闭</el-button>
              </div>
            </el-dialog>
          </el-main>
        </div>
      </div>
    </el-container>
  </el-container>
</template>

<script>

import axios from "axios";

export default {
  // 指定 name 选项的另好处是便于调试。有名字的组件有更友好的警告信息.
  // 另外，当在有 vue-devtools，未命名组件将显示成 <AnonymousComponent>，这很没有语义。通过提供 name 选项，可以获得更有语义信息的组件树。
  name: 'Home',
  data() {
    return {
      // 消息
      // 支付宝
      // 便签列表
      alipaytShow: false,
      sxsj: 2,
      sxsjtime: '',
      alipaytForm: {},
      app_asideId: 1,
      CNavshow: false,
      headInput: '',
      passwordForm: [],
      currentPage2: 10,
      dialogFormVisible: false,
      tableData: [],
      taskFrom: [],
      todos:[],
      activeTabIndex:0,
      dataall:{},
      onpage:0,
      pagesize:0,
      detailsShow:false,
      listcon: [],
      userpath:0,
    };
  },
  computed: {
    notes() {
      return this.$store.getters.allNotes;
    }
  },
  watch: {
    // 监听sxsjtime的变化
    sxsjtime(newValue, oldValue) {
      this.sxsj=0;
      this.tohome()
    }
  },
  mounted() {
    // this.drawChart1();
    // this.drawChart2();
    this.todos=this.$store.state.tags
    this.fetchTableData();
    this.userpath=this.$store.state.userpath
  },
  methods: {
    fetchTableData() {
      console.log(111)
      axios.get(this.$store.state.apiUrl+'/?a=ajax_select&m=home')
          .then(response => {
            this.dataall = response.data;
            this.$nextTick(() => {
              this.drawChart1();
              this.drawChart2();
              this.list();
            });
          })
          .catch(error => {
            // 处理错误情况
            console.error("There was an error!", error);
          });
    },
    tohome(){
      this.taskFrom.sxsj=this.sxsj
      this.taskFrom.sxsjtime=this.sxsjtime
      const formDataa = {
        ...this.taskFrom // 使用展开运算符来复制this.demandForm的所有属性
      };
      axios.post(this.$store.state.apiUrl+'/?a=ajax_select&m=home', formDataa, {
        headers: {
          'Content-Type': 'application/json' // 设置请求头为JSON
        }
      })
          .then(response => {
            this.dataall = response.data;
            this.$nextTick(() => {
              this.drawChart1();
              this.drawChart2();
            });
          })
          .catch(error => {
            // 处理错误情况
            console.error("There was an error!", error);
          });
    },
    sxsjon(e){
      this.sxsj=e;
      this.tohome()
    },
    switchTab(index) {
      this.$router.push(this.todos[index].path); // 使用push保留历史记录，或使用replace不保留
    },
    removeTodo(index) {
      this.todos.splice(index, 1);
      this.$forceUpdate();
      if(index==this.activeTabIndex){
        this.$router.push(this.todos[index].path);
      }else if(index<this.activeTabIndex){
        this.activeTabIndex=this.activeTabIndex-1
      }
    },
    drawChart1() {
      let main1 = this.$refs.main1
      // 基于准备好的dom，初始化echarts实例  这个和上面的main对应
      let myChart1 = this.$echarts.init(main1);
      var option1;
      if(this.userpath==1){
        option1 = {
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            right: '50px',
            top: '0',
            data: [ '进行中', '待接单', '撤销订单', '完结订单']
          },
          grid: {
            top: '70px',
            left: '0',
            right: '10px',
            bottom: '0',
            containLabel: true
          },
          toolbox: {
            right: '0px',
            top: '-5px',
            feature: {
              saveAsImage: {

              }
            }
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: this.dataall.days
          },
          yAxis: {
            type: 'value',
            // data: ['200','400','600','800','1000']
          },
          series: [
            {
              name: '进行中',
              type: 'line',
              stack: 'Total',
              data:  this.dataall.jxzall
            },
            {
              name: '待接单',
              type: 'line',
              stack: 'Total',
              data: this.dataall.zcdall
            },
            {
              name: '撤销订单',
              type: 'line',
              stack: 'Total',
              data: this.dataall.zjfall
            },
            {
              name: '完结订单',
              type: 'line',
              stack: 'Total',
              data: this.dataall.zwjall
            }
          ]
        };
      }else{
        option1 = {
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            right: '50px',
            top: '0',
            data: ['发布总数', '进行中', '待审核', '撤销订单', '完结订单']
          },
          grid: {
            top: '70px',
            left: '0',
            right: '10px',
            bottom: '0',
            containLabel: true
          },
          toolbox: {
            right: '0px',
            top: '-5px',
            feature: {
              saveAsImage: {

              }
            }
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: this.dataall.days
          },
          yAxis: {
            type: 'value',
            // data: ['200','400','600','800','1000']
          },
          series: [
            {
              name: '发布总数',
              type: 'line',
              stack: 'Total',
              data: this.dataall.znumall
            },
            {
              name: '进行中',
              type: 'line',
              stack: 'Total',
              data:  this.dataall.jxzall
            },
            {
              name: '待审核',
              type: 'line',
              stack: 'Total',
              data: this.dataall.zcdall
            },
            {
              name: '撤销订单',
              type: 'line',
              stack: 'Total',
              data: this.dataall.zjfall
            },
            {
              name: '完结订单',
              type: 'line',
              stack: 'Total',
              data: this.dataall.zwjall
            }
          ]
        };
      }

      option1 && myChart1.setOption(option1);
    },
    drawChart2() {
      let main = this.$refs.main2
      // 基于准备好的dom，初始化echarts实例  这个和上面的main对应
      let myChart = this.$echarts.init(main);
      let option = {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          bottom: '0',
          left: '0',
          itemWidth: 11,
          itemHeight: 11,
        },
        series: [
          {
            name: '订单价格',
            type: 'pie',
            radius: ['40%', '80%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 12,
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: this.dataall.jgqj
          }
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },
    MImaShowa(){
      const formData = {
        ...this.passwordForm // 使用展开运算符来复制this.demandForm的所有属性
      };
      axios.post(this.$store.state.apiUrl+'/?a=ajax_edit&m=userpwd', formData, {
        headers: {
          'Content-Type': 'application/json' // 设置请求头为JSON
        }
      })
          .then(response => {
            const data=response.data
            if(data.status==1){
              this.$message({
                type: 'success',
                message: '操作成功'
              });
              this.dialogFormVisible = false;
              this.passwordForm=[]
            }else{
              this.$message({
                type: 'info',
                message: data.msg
              });
            }
          })
          .catch(error => {
            // 处理错误情况
            console.error("There was an error!", error);
          });
    },
    list(){
      this.taskFrom.page=1

      const formDataa = {
        ...this.taskFrom // 使用展开运算符来复制this.demandForm的所有属性
      };
      axios.post(this.$store.state.apiUrl+'/?a=ajax_select&m=tasklist&lx=1', formDataa, {
        headers: {
          'Content-Type': 'application/json' // 设置请求头为JSON
        }
      })
          .then(response => {
            const data=response.data
            if(data.status==1){
              this.tableData=data.arr
              this.pagesize=data.pagesize
            }else{
              this.$message({
                type: 'info',
                message: data.msg
              });
            }
          })
          .catch(error => {
            // 处理错误情况
            console.error("There was an error!", error);
          });
    },
    sizechange(val){
      this.taskFrom.size = val
      this.taskFrom.page = 0
      const formDataa = {
        ...this.taskFrom // 使用展开运算符来复制this.demandForm的所有属性
      };
      axios.post(this.$store.state.apiUrl+'/?a=ajax_select&m=tasklist&lx=1', formDataa, {
        headers: {
          'Content-Type': 'application/json' // 设置请求头为JSON
        }
      })
          .then(response => {
            const data=response.data
            if(data.status==1){
              this.tableData=data.arr
              this.pagesize=data.pagesize
            }else{
              this.$message({
                type: 'info',
                message: data.msg
              });
            }
          })
          .catch(error => {
            // 处理错误情况
            console.error("There was an error!", error);
          });
    },
    handleCurrentChange(val){
      this.taskFrom.page = val
      const formDataa = {
        ...this.taskFrom // 使用展开运算符来复制this.demandForm的所有属性
      };
      axios.post(this.$store.state.apiUrl+'/?a=ajax_select&m=tasklist&lx=1', formDataa, {
        headers: {
          'Content-Type': 'application/json' // 设置请求头为JSON
        }
      })
          .then(response => {
            const data=response.data
            if(data.status==1){
              this.tableData=data.arr
              this.pagesize=data.pagesize
            }else{
              this.$message({
                type: 'info',
                message: data.msg
              });
            }
          })
          .catch(error => {
            // 处理错误情况
            console.error("There was an error!", error);
          });
    },
    detailsShowa(e){
      axios.get(this.$store.state.apiUrl+'/?a=ajax_select&m=order_info&id='+e)
          .then(response => {
            this.listcon = response.data.arr;
            console.log(this.listcon.price)
            this.detailsShow = true;
          })
          .catch(error => {
            // 处理错误情况
            console.error("There was an error!", error);
          });
    },
  },
}
</script>

<style>
.app_mian {
  display: flex;
  justify-content: space-between;
}

.app_mianCon {
  width: calc(100% - 320px);
}

.app_mdBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.app_mdItem {
  width: 19%;
  padding: 30px;
  border-radius: 16px;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.app_mdIcon {
  /* width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f1f2f3; */
}

.app_mdIcon svg {
  width: 30px;
  height: 30px;
  position: relative;
}

.app_mdIcon svg path {
  fill: #FF5000;
}

.app_mdItem p {
  font-size: 16px;
  margin: 5px 0 10px 0;
}

.app_mdNum {
  display: flex;
  align-items: center;
}

.app_mdNum b {
  font-size: 32px;
  font-weight: 600;
  line-height: 1;
  color: #555;
  font-family: 'Montserrat';
}

.app_mdNum i {
  font-size: 12px;
  margin-left: 5px;
}



.app_con {
  width: 100%;
  height: calc(100% - 60px);
  display: flex;
  justify-content: space-between;
}

.app_CNav {
  width: 150px !important;
  height: 100%;
  background: #fff;
  border-right: 1px solid rgba(0, 0, 0, .1);
}

.app_CList {
  position: relative;
  padding: 10px 0;
}

.app_CItem {
  display: flex;
  align-items: center;
  width: 100%;
  height: 60px;
  padding: 0 20px;
  position: relative;
  cursor: pointer;
}

.app_CIcon {
  display: inline-flex;
  margin-right: 5px;
}

.app_CIcon svg {
  width: 20px;
  height: 20px;
}

.app_CIcon svg path {
  fill: #333;
}

.el-menu-item {
  position: relative;
}

.app_CItem.app_CAct {
  background: rgb(255, 80, 0, 0.1);
}

.app_CItem.app_CAct span {
  color: #FF5000;
}

.app_CItem:focus,
.app_CItem:hover {
  outline: 0;
  background-color: rgb(255, 80, 0, .1) !important;
}

.app_CItem.app_CAct .app_CIcon svg path {
  fill: #FF5000;
}

.app_CItem::after {
  width: 2px;
  height: 0%;
  position: absolute;
  right: 0;
  top: 0;
  background: #FF5000;
  content: '';
  transition: all 0.48s;
}

.app_CAct.app_CItem::after {
  height: 100%;
}


/* 订单统计 */
.app_mSBox {
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  margin: 20px 0;
  padding: 20px;
}

.app_mSTit {
  padding: 20px 0;
  /* border-bottom: 1px solid rgba(0, 0, 0, .1); */
  /* background: #FF5000; */
}

.app_mSTit p {
  font-size: 20px;
  font-weight: 600;
}

.app_mSTBox {
  margin-top: -40px;
  /* padding: 20px; */
}

.app_mSTt {
  width: 100%;
  height: 420px;
}




/* 订单列表 */

.app_mlBox {
  background: #fff;
  border-radius: 16PX;
  padding: 20px;
}

.app_mlTop {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.app_mlTop P {
  font-size: 20px;
  font-weight: 600;
}

.app_mlRig {
  display: flex;
  align-items: center;
}

.app_mlIcon {
  font-size: 20px;
}
















.app_mianRig {
  width: 300px;
}

.app_mgBox {
  width: 100%;
  padding: 30px;
  background: #fff;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.app_mglogo {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  overflow: hidden;
  box-shadow: 0 0 10px rgba(0, 0, 0, .1);
}

.app_mglogo img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.app_mgTit {
  font-size: 20px;
  font-weight: 600;
  margin: 10px 0 20px;
}

.app_mgItem {
  width: 100%;
  font-size: 14px;
  margin-bottom: 12px;
}

.app_mgItem span {
  color: #FF5000;
  cursor: pointer;
  font-size: 14px;
}

.app_mgBtn {
  width: 100%;
  height: 50px;
  border-radius: 50px;
  background: #FF5000;
  color: #fff;
  font-size: 14px;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 15px;
  text-decoration: none;
}

.app_mjBox {
  width: 100%;
  padding: 30px;
  background: #fff;
  border-radius: 16px;
  margin-top: 20px
}

.app_mjTit {
  font-size: 20px;
  font-weight: 600;
}

.app_mjMap {
  width: 100%;
  height: 320px;
  margin-top: -30px
}

.myChart {
  width: 100%;
  height: 100%
}










.el-dialog__header {
  background: #FF5000;
}

.el-dialog {
  width: 500px !important;
  border-radius: 16px !important;
  overflow: hidden;
}

.el-dialog__title {
  font-size: 18px;
  font-weight: 600;
  color: #fff !important;
  padding: 20px;
}

.Password .el-dialog__headerbtn .el-dialog__close {
  font-size: 18px;
  color: #fff;
}

.el-dialog__headerbtn:focus .el-dialog__close,
.el-dialog__headerbtn:hover .el-dialog__close {
  color: #fff !important;
}

.Password .el-input__inner {
  background: #f7f8f9;
}
.el-range-editor.el-input__inner{
  width: 250px !important;
}
.Password_hide,
.Password_hide:hover {
  background: #f7f8f9 !important;
}

.Password_hide span {
  color: #333;
}

@media(max-width:1468px) {
  .app_mianRig {
    width: 250px;
  }

  .app_mianCon {
    width: calc(100% - 270px);
  }

  .app_mdNum b {
    font-size: 28px;
  }

  .app_mdItem p {
    font-size: 14px;
  }

  .app_mdIcon svg {
    width: 26px;
    height: 26px;
  }

  .app_mgBox {
    padding: 20px
  }

  .app_mgItem {
    font-size: 13px;
  }
}

@media(max-width:1280px) {
  .app_mianRig {
    width: 230px;
  }

  .app_mianCon {
    width: calc(100% - 250px);
  }
}
</style>
<style>
.app_mMBox{
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.app_mMItem{
  background: #fff;
  padding: 8px 20px;
  font-size: 14px;
  margin-right: 12px;
  cursor: pointer;
  border-radius: 8px;
}
.app_mMItem.active{
  background: #FF5000;
  color: #fff;
}
</style>